import { MantineDataTable,
    DataTableTokenPagination,
} from '@flexinet/ui-components';
import { Stack } from '@mantine/core';
import { useAllAliases } from '../hooks/useAllAliases';
import { useAliasesTableColumns } from '../hooks/useAliasesTableColumns';
import { useRef } from 'react';

export const AliasesTable = () => {
    const { visibleItems, loading, nextToken, fetchRecords, isFetchingNextPage, visibleCount } = useAllAliases();
    const columns = useAliasesTableColumns();
    const scrollViewportRef = useRef<HTMLDivElement>(null);

    return (
        <Stack gap="lg">
            <MantineDataTable
                columns={columns}
                records={visibleItems}
                fetching={loading}
                withTableBorder={true}
                onScrollToBottom={fetchRecords}
                scrollViewportRef={scrollViewportRef}
            />
            <DataTableTokenPagination
                loadedCount={visibleCount}
                nextToken={nextToken}
                handleLoadMore={fetchRecords}
                isFetchingMore={isFetchingNextPage}
            />
        </Stack>
    );
};
